import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import { errorToast } from "../../../utils/toast";
import { FiCreditCard, FiUser } from "react-icons/fi";
import { MdQrCode2 } from "react-icons/md";
import { RiBankLine } from "react-icons/ri";
import { TbId } from "react-icons/tb";
import { FaAngleLeft } from "react-icons/fa";

const BankDetails = () => {
  const navigate = useNavigate();
  const [bankDetails, setBankDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const { data } = await axios.get("getKyc");
        setBankDetails(data?.result || null);
      } catch (error) {
        console.error("Failed to load bank details:", error);
        errorToast(error?.response?.data?.message || "Failed to load bank details");
      } finally {
        setLoading(false);
      }
    };

    fetchBankDetails();
  }, []);

  const detailRows = [
    {
      label: "Account Holder",
      value: bankDetails?.holderName,
      icon: <FiUser className="h-6 w-6 text-[#5B2A6D]" />,
    },
    {
      label: "Bank Name",
      value: bankDetails?.bankName,
      icon: <RiBankLine className="h-6 w-6 text-[#5B2A6D]" />,
    },
    {
      label: "Account Number",
      value: bankDetails?.accountNo,
      icon: <FiCreditCard className="h-6 w-6 text-[#5B2A6D]" />,
    },
    {
      label: "IFSC Code",
      value: bankDetails?.ifsc,
      icon: <TbId className="h-7 w-7 text-[#5B2A6D]" />,
    },
    {
      label: "UPI ID",
      value: bankDetails?.upiId,
      icon: <MdQrCode2 className="h-7 w-7 text-[#5B2A6D]" />,
    },
  ];

  const kycStatus = bankDetails?.status || "Pending";
  const isVerified = ["verified", "approved", "completed"].includes(
    String(kycStatus).toLowerCase()
  );

  return (
   <div className="h-screen overflow-hidden bg-[#F7F4FB] px-4 py-1 lg:py-12 text-slate-900">
      <div className="mx-auto max-w-2xl">
        <div className="mb-5 flex items-center mt-4 gap-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white/60"
          >
            <FaAngleLeft className="h-7 w-7 text-black " />
          </button>
          <h1 className="text-2xl font-bold text-black">Bank Settings</h1>
        </div>

        {loading ? (
          <div className="flex min-h-[50vh] items-start text-left">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#4B1D67] border-t-transparent" />
          </div>
        ) : (
          <>
<section className="rounded-[26px] bg-white px-5 py-4 shadow-sm">
                <h2 className="text-xl font-extrabold text-[#191422] items-start text-left">
                Withdrawal Account
              </h2>
              <p className="mt-3 text-md font-medium text-[#6F6879] items-start text-left">
                Add bank and UPI details
              </p>
        <div className="text-left">
  <div
    className={`mt-3 inline-flex rounded-full border px-6 py-3 text-base font-bold items-start ${
      isVerified
        ? "border-green-500 text-green-600"
        : "border-black text-[#A26C00]"
    }`}
  >
    {isVerified ? "Verified" : kycStatus || "Pending"}
  </div>
</div>
            </section>

<section className="mt-3 rounded-[26px] bg-white px-5 py-4 shadow-sm text-left"> 
               <div className="space-y-4">
                {detailRows.map((item) => (
                  <div key={item.label} className="flex items-center gap-6">
<div className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-xl bg-[#F1E8F9]">
                        {item.icon}
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-sm font-semibold leading-tight text-[#191422]">
                        {item.label}
                      </h3>
                      <p className="mt-1 break-all text-sm font-medium text-[#6F6879]">
                        {item.value || "Not added"}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <button
              type="button"
              onClick={() => navigate("/dash/kyc-status")}
className="mt-4 flex w-full items-center justify-center rounded-full bg-[#F9A826] px-6 py-3 text-lg font-bold text-white"
            >
              Add KYC Details
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BankDetails;
